import { request } from '@umijs/max';
import { Button, Space, Typography } from 'antd';
import React, { useMemo, useState } from 'react';

const CONSENT_STORAGE_KEY = 'wis_cookie_consent_accepted';

const canUseStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const hasConsent = () => {
  if (!canUseStorage()) return true;
  return window.localStorage.getItem(CONSENT_STORAGE_KEY) === 'true';
};

const CookieConsent: React.FC = () => {
  const [accepted, setAccepted] = useState(hasConsent);

  const containerStyle = useMemo(
    () => ({
      position: 'fixed' as const,
      left: 16,
      right: 16,
      bottom: 16,
      zIndex: 1000,
      borderRadius: 12,
      border: '1px solid #d9d9d9',
      background: '#ffffff',
      padding: '12px 16px',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
      display: accepted ? 'none' : 'block',
    }),
    [accepted],
  );

  const onAccept = async () => {
    if (canUseStorage()) {
      window.localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
    }
    setAccepted(true);
    try {
      await request('/bff/gateway/user/cookie-consent', {
        method: 'POST',
        skipErrorHandler: true,
      });
    } catch (_error) {
      // noop
    }
  };

  if (accepted) {
    return null;
  }

  return (
    <div style={containerStyle}>
      <Space
        direction="horizontal"
        size={12}
        style={{ width: '100%', justifyContent: 'space-between' }}
      >
        <Typography.Text style={{ color: '#595959' }}>
          我们使用必要 Cookie
          来维持登录状态与消息服务连接，继续使用即表示你同意相关 Cookie。
        </Typography.Text>
        <Button type="primary" onClick={onAccept}>
          接受并继续
        </Button>
      </Space>
    </div>
  );
};

export default CookieConsent;
